import { colors, EditableInfoBlock } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const EditableInfoBlockStyled = styled(EditableInfoBlock)`
  background-color: ${colors.neutral.white};
  margin-bottom: 8rem;
`;
